import { MDropdown } from '@Components/Base';
import { ColumnDataType } from '@Features/EmployeeSelfService/TaskList/list/type';
import ESSFeatureRoutePath from '@Features/router/ess/ESSFeatureRoutePath.enum';
import { MoreOutlined } from '@ant-design/icons';
import { ReactComponent as ViewIcon } from '@Icons/additional/eye.svg';
import { ReactComponent as TimeLoading } from '@Icons/additional/time-loading.svg';
import { Flex, MenuProps } from 'antd';
import { Link, generatePath } from 'react-router-dom';
import {
  ApprovalsTasksRequisitionResponse,
  ApprovalsTasksResponse,
} from '@Types/api/approvalsList';
import { RejectTask, ApproveTask } from './components';

interface TableTaskListActionProps {
  record:
    | ColumnDataType
    | ApprovalsTasksResponse
    | ApprovalsTasksRequisitionResponse;
  context?: 'desktop' | 'mobile';
  onApproveReject?: () => void;
  onApprovalHistory?: (requestNo: string, isIt?: boolean) => void;
}

interface ActionRecord {
  taskId: string | undefined;
  requestId: number | undefined;
  statusId: number | undefined;
  requestNo: string | undefined;
  requestTypeId: string | undefined;
}

interface Params {
  taskId: string;
  requestId: number;
  requestTypeId?: string;
  statusId?: number;
}

const TableTaskListActions: React.FC<TableTaskListActionProps> = ({
  record,
  onApproveReject,
  onApprovalHistory,
  context = 'desktop',
}) => {
  let actionRecord: ActionRecord = {
    taskId: '',
    requestId: undefined,
    requestNo: '',
    requestTypeId: '',
    statusId: undefined,
  };

  const essRecord = record as ApprovalsTasksResponse | ColumnDataType;

  const mrRecord = record as ApprovalsTasksRequisitionResponse;

  if (essRecord?.requestId) {
    actionRecord = {
      requestId: essRecord.requestId,
      requestNo: essRecord.requestNo,
      requestTypeId: String(essRecord.requestTypeId),
      statusId: essRecord.statusId,
      taskId: essRecord.taskId,
    };
  }

  if (mrRecord.reqId) {
    actionRecord = {
      requestId: mrRecord.reqId,
      requestNo: mrRecord.reqNo,
      requestTypeId:
        String(essRecord.requestTypeId) || String(mrRecord.service),
      statusId: mrRecord.statusId,
      taskId: mrRecord.taskId,
    };
  }

  const { taskId, requestId, requestNo, requestTypeId, statusId } =
    actionRecord;

  const params: Params = {
    taskId: taskId!,
    requestId: requestId!,
    requestTypeId: String(requestTypeId!),
  };

  const path = generatePath(ESSFeatureRoutePath.TASK_APPROVE_REQUEST, params);
  const isItRequisition = requestTypeId === 'IT Requisition';

  const items = (): MenuProps['items'] => [
    {
      label: (
        <ApproveTask
          taskId={taskId!}
          requestNo={requestNo}
          requestId={requestId!}
          requestTypeId={String(requestTypeId!)}
          statusId={statusId}
          onApprove={onApproveReject}
        />
      ),
      key: '0',
    },
    {
      label: (
        <RejectTask
          taskId={taskId!}
          requestNo={requestNo}
          requestId={requestId!}
          requestTypeId={String(requestTypeId!)}
          statusId={statusId}
          onReject={onApproveReject}
        />
      ),
      key: '1',
    },
    {
      label: (
        <Link to={path} title="View">
          <Flex className="trojan-action-space" gap={15} onClick={() => null}>
            <ViewIcon /> <span>View</span>
          </Flex>
        </Link>
      ),
      key: '2',
    },
    {
      label: (
        <Flex
          className="trojan-action-space"
          gap={15}
          onClick={() =>
            onApprovalHistory &&
            onApprovalHistory(String(requestId), isItRequisition)
          }
        >
          <TimeLoading /> <span>Approval History</span>
        </Flex>
      ),
      key: '3',
    },
  ];

  if (context === 'mobile') {
    return (
      <div>
        <Flex
          justify="center"
          align="center"
          style={{ height: '100%', marginLeft: '15px' }}
        >
          <MDropdown menu={{ items: items() }} trigger={['click']}>
            <MoreOutlined />
          </MDropdown>
        </Flex>
      </div>
    );
  }

  return (
    <div>
      <Flex className="trojan-action-space" style={{ marginLeft: '15px' }}>
        <MDropdown menu={{ items: items() }} trigger={['click']}>
          <MoreOutlined />
        </MDropdown>
      </Flex>
    </div>
  );
};

export default TableTaskListActions;
